export const BOSCH_FONT_ICON_CSS_CLASS_PREFIX = "boschicon-bosch-ic-";
export const BOSCH_UI_ICON_CSS_CLASS_PREFIX = "ui-ic-";
export const PAU_BBG_FONT_ICONS_CSS_CLASS_PREFIX = "pau-icon-";
